import type { ClientOrganization } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC, PropsWithChildren } from 'react';

import { OrganizationAccessContext } from '@/shared/components/organization/useOrganizationAccessContextValue';
import { useOrganizationAccessValue } from '@/shared/components/organization/useOrganizationAccessValue';

type Props = {
  organization: ClientOrganization | undefined;
};

/**
 * Computes the permission context value for a single organization once and
 * shares it with every descendant guard / consumer via context. Mount this
 * inside a screen that focuses one organization (e.g. the organization detail
 * screen).
 *
 * A global organization admin is granted before the resolver even reads the
 * per-organization role.
 */
export const OrganizationAccessProvider: FC<PropsWithChildren<Props>> = ({
  organization,
  children
}) => {
  const contextValue = useOrganizationAccessValue(organization);

  return (
    <OrganizationAccessContext.Provider value={contextValue}>
      {children}
    </OrganizationAccessContext.Provider>
  );
};
